import React from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SurveyComponent } from '../../../../models/SurveyTemplates';
import { Namespace } from '../../../../locales/translations';

interface NumberInputFieldProps {
    field: SurveyComponent;
    value?: number;
    onChange?: (value: number | undefined) => void;
    disabled?: boolean;
}

const NumberInputField: React.FC<NumberInputFieldProps> = ({
    field,
    value,
    onChange,
    disabled = false
}) => {
    const { t } = useTranslation([Namespace.SURVEY_BUILDER]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        if (newValue === '') {
            onChange?.(undefined);
        } else {
            const numValue = parseFloat(newValue);
            if (!isNaN(numValue)) {
                onChange?.(numValue);
            }
        }
    };

    return (
        <TextField
            fullWidth
            type="number"
            value={value ?? ''}
            onChange={handleChange}
            placeholder={field.placeholder || t('field_messages.number_input.enter_placeholder', { label: field.label.toLowerCase() }) as string}
            disabled={disabled}
            inputProps={{
                min: field.properties?.min || undefined,
                max: field.properties?.max || undefined,
                step: field.properties?.step || 1,
            }}
        />
    );
};

export default NumberInputField;
